import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useTheme } from '../../contexts/ThemeContext';

const Layout = ({ children, currentPage, setCurrentPage, userInfo, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isDarkMode } = useTheme();

  return (
    <div className="h-screen bg-gray-50 dark:bg-gray-900 relative overflow-hidden transition-colors">
      {/* Sidebar - Fixed positioning */}
      <Sidebar 
        currentPage={currentPage} 
        setCurrentPage={setCurrentPage}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      {/* Main Content Area - With left margin to avoid sidebar overlap */}
      <div className="lg:ml-72 h-full flex flex-col">
        {/* Mobile Header */}
        <div className="lg:hidden bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-4 py-3 flex items-center justify-between flex-shrink-0 transition-colors">
          <button
            onClick={() => setSidebarOpen(true)}
            className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 focus:outline-none transition-colors"
          >
            <i className="fas fa-bars text-xl"></i>
          </button>
          {/* Mobile Header with Profile */}
          <div className="relative">
            <Header 
              userInfo={userInfo}
              onLogout={onLogout}
              isMobile={true}
            />
          </div>
        </div>
        {/* Desktop Header */}
        <div className="hidden lg:block flex-shrink-0">
          <Header 
            userInfo={userInfo}
            onLogout={onLogout}
            isMobile={false}
          />
        </div>
        {/* Page Content - Scrollable */}
        <main className="flex-1 overflow-y-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;